module.exports = __webpack_public_path__ + "static/media/waterFilterCorrect.daf66254.png";